import { useQuery } from '@tanstack/react-query';
import { useApi, useApiProblem } from '@/shared/api';

/**
 * Die Kanal-Worker halten den Katalog frisch; der Dialog liest nur. Kann der Server keine Kanäle
 * liefern, nennt seine Antwort den Grund, und der Dialog zeigt genau diesen: nur der Server weiß,
 * warum kontoweit kein Kanal geladen wurde.
 */
export function useChannelCloseoutOptions(propertyGroupId: string, enabled: boolean) {
  const api = useApi();
  const options = useQuery({
    queryKey: ['availability-distribution', 'closeout-options', propertyGroupId],
    queryFn: () => api.availabilityDistribution.closeouts.options(propertyGroupId),
    enabled,
    retry: false,
  });
  return { options, problem: useApiProblem(options.error) };
}
